import request from '@/config/axios'

export interface InventoryVO {
  id: string | number
  shopId: string | number
  spuId: string | number
  skuId?: string | number
  date: string
  totalCount: number
  lockedCount: number
  soldCount: number
  availableCount: number
}

export interface BatchSetDTO {
  shopId: string | number
  spuId: string | number
  skuId?: string | number
  startDate: string
  endDate: string
  totalCount: number
}

// 日历库存查询
export const queryCalendar = (params: any) => {
  return request.get({ url: '/hotel/inventory/list-by-date-range', params })
}

// 批量设置库存
export const batchSet = (data: BatchSetDTO) => {
  return request.post({ url: '/hotel/inventory/batch-set', data })
}

// 获取单条库存
export const getInventory = (id: string | number) => {
  return request.get({ url: '/hotel/inventory/get?id=' + id })
}
